export const OTHER_ANTIFOULING_MANUFACTURER_VALUE = "Other...";
export const NO_ANTIFOULING_BOOT_TOP_OPTION = { value: "No A/F", label: "No A/F" };
export const BOOT_TOP_GUIDANCE =
  "Select the coating applied between the light and loaded waterlines. Choose No A/F when no antifouling coating is applied.";
export const SERVICE_LIFE_GUIDANCE = "Enter the manufacturer's specified antifouling-system service life in months.";
